<header class="navbar" [class.navbar-hidden]="isNavbarHidden" itemscope itemtype="http://schema.org/SiteNavigationElement">
  <div class="navbar-container">
    <!-- Linker Bereich (leer für Balance) -->
    <div class="navbar-left"></div>
    
    <!-- Logo in der Mitte -->
    <div class="navbar-center">
      <a routerLink="/" class="logo">
        <img fill [ngSrc]="imageService.getOptimizedImageUrl(logoImage, { width: 300 })" [alt]="logoAltText" fill class="logo-image" priority>
      </a>
    </div>
    <!-- Navigation rechts -->
    <nav class="navbar-right">
      <ul class="nav-links">
        <!-- <li>
          <a routerLink="/angebote" routerLinkActive="active" class="discount-link">
            Angebote
            <svg xmlns="http://www.w3.org/2000/svg" class="discount-icon" width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="var(--primary-color)" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <line x1="9" y1="15" x2="15" y2="9" />
              <circle cx="9.5" cy="9.5" r=".5" />
              <circle cx="14.5" cy="14.5" r=".5"/>
              <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" />
            </svg>
          </a>
        </li> -->
        <li *ngIf="isAuthor"><a routerLink="/dashboard" routerLinkActive="active">Dashboard</a></li>
        <li><a [routerLink]="seasonCalendarPath" routerLinkActive="active">Saisonkalender</a></li>
        <li><a [routerLink]="lexiconOverviewPath" routerLinkActive="active">Kräuter-Lexikon</a></li>
        <li><a [routerLink]="blogPath" routerLinkActive="active">Blog</a></li>
        <!-- <li>
          <a routerLink="/tipps-anbau" routerLinkActive="active">
            <span class="full-text">Tipps & Anbau</span>
            <span class="short-text">Tipps</span>
          </a>
        </li> -->
        <li>
          <a [routerLink]="aboutPath" routerLinkActive="active">
            <span class="full-text">Über uns</span>
            <span class="short-text">Über</span>
          </a>
        </li>
      </ul>
      
      <!-- Suchsymbol -->
      <!-- <div class="search-icon" (click)="toggleSearch()" aria-label="Suche öffnen">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" 
             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div> -->
      
      <!-- Mobile Menu Button -->
      <button class="mobile-menu-btn" 
              [class.active]="isMobileMenuOpen"
              (click)="toggleMobileMenu()" 
              aria-label="Menü öffnen" 
              [attr.aria-expanded]="isMobileMenuOpen">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </button>
    </nav>
  </div>
  
  <!-- Mobile Navigation Menu -->
  <div class="mobile-menu" 
       [class.open]="isMobileMenuOpen" 
       [attr.aria-hidden]="!isMobileMenuOpen">
    <ul class="mobile-nav-links">
      <li>
        <!-- <a routerLink="/angebote" routerLinkActive="active" (click)="closeMobileMenu()" class="discount-link">
          Angebote
          <svg xmlns="http://www.w3.org/2000/svg" class="discount-icon" width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="var(--accent-color)" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <line x1="9" y1="15" x2="15" y2="9" />
            <circle cx="9.5" cy="9.5" r=".5" fill="var(--accent-color)" />
            <circle cx="14.5" cy="14.5" r=".5" fill="var(--accent-color)" />
            <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" />
          </svg>
        </a> -->
      </li>
      <li *ngIf="isAuthor"><a routerLink="/dashboard" routerLinkActive="active" (click)="closeMobileMenu()">Dashboard</a></li>
      <li><a [routerLink]="seasonCalendarPath" routerLinkActive="active" (click)="closeMobileMenu()">Saisonkalender</a></li>
      <li><a [routerLink]="lexiconOverviewPath" routerLinkActive="active" (click)="closeMobileMenu()">Kräuter-Lexikon</a></li>
      <li><a [routerLink]="blogPath" routerLinkActive="active" (click)="closeMobileMenu()">Blog</a></li>
      <!-- <li><a routerLink="/tipps-anbau" routerLinkActive="active" (click)="closeMobileMenu()">Tipps & Anbau</a></li> -->
      <li><a [routerLink]="aboutPath" routerLinkActive="active" (click)="closeMobileMenu()">Über uns</a></li>
      <!-- <li><a routerLink="/suche" routerLinkActive="active" (click)="closeMobileMenu()">Suche</a></li> -->
    </ul>
  </div>
  
  <!-- Suchoverlayer -->
  <!-- <div class="search-overlay" [class.active]="isSearchActive">
    <div class="search-container">
      <form (submit)="handleSearch($event)">
        <input type="text" [(ngModel)]="searchQuery" name="query" placeholder="Kräuter, Rezepte, Tipps..." 
               autocomplete="off" [autofocus]="isSearchActive">
        <button type="submit">Suchen</button>
      </form>
      <button class="close-search" (click)="toggleSearch()" aria-label="Suche schließen">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" 
             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div> -->
</header>


